export default __webpack_public_path__ + "static/media/logo.a995e45c.svg";